"use strict";

exports.__esModule = true;
exports.getThresholdColor = void 0;
var _polished = require("polished");
/**
 * Given a list of thresholds, get the appropriate color for a value.
 */
var getThresholdColor = exports.getThresholdColor = function getThresholdColor(thresholds, value) {
  if (!thresholds || Array.isArray(thresholds) && thresholds.length === 0) {
    return "transparent";
  }
  var lower;
  var upper;
  for (var i = 0; i < thresholds.length; i++) {
    var threshold = thresholds[i];
    if (value <= threshold[0]) {
      if (lower === undefined) {
        lower = threshold;
      }
      upper = threshold;
      break;
    }
    lower = threshold;
  }
  if (lower === undefined) {
    lower = thresholds[0];
  }
  if (upper === undefined) {
    upper = thresholds[thresholds.length - 1];
  }
  if (lower === upper) {
    return lower[1];
  }
  var lowerX = lower[0];
  var upperX = upper[0] - lowerX;
  var weight = (value - lowerX) / upperX;
  return (0, _polished.mix)(weight, upper[1], lower[1]);
};